interface CustomWebdemoConfig {
	companyName?: String;
}
const customConfig: CustomWebdemoConfig = window["custom"];
const placeholderCompany = "Sample Group";

const planName = planName => {
	if (!planName) {
		return "";
	}
	return planName.replace(placeholderCompany, customConfig?.companyName);
};

const planUrl = (url: string): string => {
	const newUrl = url.replace("./react/index.html#", "");
	return newUrl;
};

const customize = {
	planName,
	planUrl,
};

export default customize;
